

import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {ITransaction, Transaction} from '../../shared/model/transaction.model';
import {Injectable} from '@angular/core';
import {SERVER_API_URL} from '../../app.constants';
import {Observable} from 'rxjs/index';
import {map} from 'rxjs/internal/operators';
import {createRequestOption} from '../../shared/util/request-util';
// import {DATE_FORMAT, DATE_TIME_FORMAT} from '../../shared/constants/input.constants';
// import moment = require('jalali-moment');
// import * as moment from 'jalali-moment';
// import * as XLSX from 'xlsx';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import {ITransactionView} from "../../shared/model/transactionView.model";

type EntityResponseType = HttpResponse<ITransaction>;
type EntityArrayResponseType = HttpResponse<ITransaction[]>;
// import * as FileSaver from 'file-saver';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({ providedIn: 'root' })
export class TransactionService {
    public resourceUrl = SERVER_API_URL + 'api/transactions';

    constructor(protected http: HttpClient) {}

    create(transaction: ITransaction): Observable<EntityResponseType> {
      // alert(' in create action date ==' + transaction.actionDate)
        const copy = this.convertDateFromClient(transaction);
      // alert(' in creat ecopy action date ==' + copy.actionDate)

      return this.http
            .post<ITransaction>(this.resourceUrl, copy, { observe: 'response' })
            .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
    }
    createPeriodic(transaction: ITransaction): Observable<EntityResponseType> {
      // alert(' in create action date ==' + transaction.actionDate)
        const copy = this.convertDateFromClient(transaction);
      // alert(' in creat ecopy action date ==' + copy.actionDate)

      return this.http
            .post<ITransaction>(this.resourceUrl+'-periodic', copy, { observe: 'response' })
            .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
    }

    update(transaction: ITransaction): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(transaction);
        return this.http
            .put<ITransaction>(this.resourceUrl, copy, { observe: 'response' })
            .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http
            .get<ITransaction>(`${this.resourceUrl}/${id}`, { observe: 'response' })
            .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
    }

    findChain(id: number): Observable<EntityArrayResponseType> {
        return this.http
            .get<ITransaction[]>(`${this.resourceUrl}/${id}/chain`, { observe: 'response' })
            .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
    }

    chainFlags(ids: number[]): Observable<HttpResponse<{ [id: string]: boolean }>> {
        let params = new HttpParams();
        (ids || []).forEach(id => {
            if (id != null) {
                params = params.append('ids', String(id));
            }
        });
        return this.http.get<{ [id: string]: boolean }>(`${this.resourceUrl}-chain-flags`, {
            params,
            observe: 'response'
        });
    }

    // findWithCustomerId(id: number): Observable<EntityResponseType> {
    //     return this.http
    //         .get<ITransaction>(`${this.resourceUrl + '-customer'}/${id}`, { observe: 'response' })
    //         .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
    // }

  checkForArchiveCustomer(id?:any): Observable<EntityResponseType> {
    // const options = createRequestOption(req);
    return this.http.get<any>(this.resourceUrl+'-check-customer-archive/'+id, {params: null, observe: 'response'});
  }

  checkForCloseProject(id?:any): Observable<EntityResponseType> {
    return this.http.get<any>(this.resourceUrl+'-check-project-close/'+id, {params: null, observe: 'response'});
  }

  checkForCloseSalesCycle(id?:any): Observable<EntityResponseType> {
    return this.http.get<any>(this.resourceUrl+'-check-close-sales-cycle/'+id, {params: null, observe: 'response'});
  }
  findAllTransactionWithCustomerId(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-customer', { params: options, observe: 'response' });
  }

  findAllTransactionWithPrijectId(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-project', { params: options, observe: 'response' });
  }

  findAllTransactionWithContractId(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-contract', { params: options, observe: 'response' });
  }

  findRunTransactionWithPrijectId(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-project-run', { params: options, observe: 'response' });
  }

  findRunTransactionWithOrderId(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-order', { params: options, observe: 'response' });
  }


  findAllTransactionWithSalesCycleId(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-sales-cycle', { params: options, observe: 'response' });
  }


  findAllTransactionWithoutPrijectId(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-without-project', { params: options, observe: 'response' });
  }

  findAllTransactionSupplier(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-supplier', { params: options, observe: 'response' });
  }




  // findWithCustomerId(id: number): Observable<EntityArrayResponseType> {
  //   return this.http
  //     .get<ITransaction[]>(`${this.resourceUrl + '-find'}/${id}`, { observe: 'response' })
  //     .pipe(map((res: EntityArrayResponseType) => this.convertDateFromServer(res)));
  // }

  // findMyTransaction(id: number): Observable<EntityArrayResponseType> {
  //   return this.http
  //     .get<ITransaction[]>(`${this.resourceUrl}`, { observe: 'response' })
  //     .pipe(map((res: EntityArrayResponseType) => this.convertDateFromServer(res)));
  // }

    // query(req?: any): Observable<EntityArrayResponseType> {
    //     const options = createRequestOption(req);
    //     return this.http
    //         .get<ITransaction[]>(this.resourceUrl, { params: options, observe: 'response' })
    //         .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
    // }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl, {params: options, observe: 'response'});
  }

  searchReportByTypeDailyStatus(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-last-status', {params: options, observe: 'response'});
  }
  searchReportByTypeDaily(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-last-count', {params: options, observe: 'response'});
  }

  searchDailyWithDetail(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-last-daily2', {params: options, observe: 'response'});
  }

  searchDailyWithDetailAndStatus(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-last-status-daily2', {params: options, observe: 'response'});
  }

  findMyTransactionCount(id: number): Observable<HttpResponse<any>> {
        // const options = createRequestOption(req);
        return this.http
            .get<any>(`${this.resourceUrl + '-self-count'}/${id}`, {  observe: 'response' });

    // return this.http.get<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });

  }

  findTransactionCountInProgressPast(): Observable<HttpResponse<any>> {
        return this.http
            .get<any>(`${this.resourceUrl + '-in-progress-past'}`, {  observe: 'response' });
  }

  findMyTransaction(id: number): Observable<EntityArrayResponseType> {
        // const options = createRequestOption(req);
        return this.http
            .get<ITransaction[]>(`${this.resourceUrl + '-self'}/${id}`, {  observe: 'response' })
            .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
    }


  getTransactionNotification(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-notifications', {params: options, observe: 'response'});
  }

  findTodayTransaction(id: number): Observable<EntityArrayResponseType> {
        // const options = createRequestOption(req);
        return this.http
            .get<ITransaction[]>(`${this.resourceUrl + '-today'}/${id}`, {  observe: 'response' })
            .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
    }

  findWithCustomerId(id: number, req?: any): Observable<EntityArrayResponseType> {
        // const options = createRequestOption(req);
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(`${this.resourceUrl + '-find'}/${id}`, {params: options, observe: 'response'});

    // return this.http
    //         .get<ITransaction[]>(`${this.resourceUrl + '-find'}/${id}`, {  observe: 'response' })
    //         .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
    }

  findActionTransactionsWithCustomerId(id: number): Observable<EntityArrayResponseType> {
        // const options = createRequestOption(req);
        return this.http
            .get<ITransaction[]>(`${this.resourceUrl + '-action-find'}/${id}`, {  observe: 'response' })
            .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
    }

  findFollowTransactionsWithCustomerId(id: number): Observable<EntityArrayResponseType> {
        // const options = createRequestOption(req);
        return this.http
            .get<ITransaction[]>(`${this.resourceUrl + '-follow-find'}/${id}`, {  observe: 'response' })
            .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    protected convertDateFromClient(transaction: ITransaction): ITransaction {
        const copy: ITransaction = Object.assign({}, transaction, {
            // expiratioDate:
            //     transaction.expiratioDate != null && transaction.expiratioDate.isValid()
            //         ? transaction.expiratioDate.format(DATE_FORMAT)
            //         : null,
            // actionDate:
            //     transaction.actionDate != null && transaction.actionDate.isValid() ? transaction.actionDate.format(DATE_FORMAT) : null,
            // followupbyDate:
            //     transaction.followupbyDate != null && transaction.followupbyDate.isValid()
            //         ? transaction.followupbyDate.format(DATE_FORMAT)
            //         : null,
          // createdDate:
          //       transaction.createdDate != null && transaction.createdDate.isValid() ? transaction.createdDate.format(DATE_TIME_FORMAT) : null
        });
        return copy;
    }

    protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
        if (res.body) {
            // res.body.expiratioDate = res.body.expiratioDate != null ? moment(res.body.expiratioDate) : null;
            // res.body.actionDate = res.body.actionDate != null ? moment(res.body.actionDate) : null;
            // res.body.followupbyDate = res.body.followupbyDate != null ? moment(res.body.followupbyDate) : null;
            // res.body.createdDate = res.body.createdDate != null ? moment(res.body.createdDate) : null;
        }
        return res;
    }

    protected convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
        if (res.body) {
            res.body.forEach((transaction: ITransaction) => {
                // transaction.expiratioDate = transaction.expiratioDate != null ? moment(transaction.expiratioDate) : null;
                // transaction.actionDate = transaction.actionDate != null ? moment(transaction.actionDate) : null;
                // transaction.followupbyDate = transaction.followupbyDate != null ? moment(transaction.followupbyDate) : null;
                // transaction.createDate = transaction.createDate != null ? moment(transaction.createDate) : null;
            });
        }
        return res;
    }



  search(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search', {params: options, observe: 'response'});
  }

  searchReport(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report', {params: options, observe: 'response'});
  }

  searchReportNila(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransactionView[]>(this.resourceUrl + '-search-report-nila', {params: options, observe: 'response'});
  }

  searchReportProjectItems(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-project-items', {params: options, observe: 'response'});
  }

  // searchReportPrjMng(req?: any): Observable<EntityArrayResponseType> {
  //   const options = createRequestOption(req);
  //   return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-prj-mng', {params: options, observe: 'response'});
  // }

  searchReportSalesCycle(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-sales-cycle', {params: options, observe: 'response'});
  }

  searchLastReportDashboard(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-last-dashboard', {params: options, observe: 'response'});
  }

  searchLastReport(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-last', {params: options, observe: 'response'});
  }

  searchLastReportContract(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-last-contract', {params: options, observe: 'response'});
  }

  searchLastReportSalesCycle(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-last-sales-cycle', {params: options, observe: 'response'});
  }
 searchLastReportSalesCycleDashboard(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-last-sales-cycle-dashboard', {params: options, observe: 'response'});
  }


  searchLastReportDaily(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-last-daily', {params: options, observe: 'response'});
  }

  searchLastReportDailySalesCycle(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransaction[]>(this.resourceUrl + '-search-report-last-daily-sales-cycle', {params: options, observe: 'response'});
  }

  assign(transaction: ITransaction): Observable<EntityResponseType> {
    return this.http.post<ITransaction>(this.resourceUrl+'-assign', transaction, {observe: 'response'});
  }


  public exportAsExcelFile(json: any[], excelFileName: string): void {
  //   // alert(' json == ' + json.length);
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportAsExcelFile2(json: Transaction[], excelFileName: string): void {
  //   // alert(' json == ' + json.length);
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}
